import { FormGroup } from "@angular/forms";

export class SaveData {
  formGroup: FormGroup;
}
